import {
  BlacklistDataContent,
  BlacklistUserInfo,
  ButtonPrimary,
  ButtonPseudo,
  ChangeLogs,
  DateInputRange,
  IconCalendar,
  PermissionDenied,
  PermissionEnum,
  Popup,
  SidePanel,
  SidePanelLoader,
  SidePanelType,
} from '@ui/src';
import { AMLPanelsTypes } from '../types';
import OngoingPanelContent from './ongoing-monitoring-panel';
import ManualRiskScoreForm from '../../../../components/common/aml/manual-risk-score-form';
import AmlChangeLogs from './change-logs';

import cn from '../styles.module.css';

const AmlPanels = ({
  exportPdfPanelVisible,
  setExportPdfPanelVisible,
  ongoingMonitoringPdfIsLoading,
  getOngoingMonitoringPdfAction,
  exportDate,
  setExportDate,
  ongoingItemIsFetching,
  ongoingItemIsLoading,
  ongoingMonitoringItem,
  setOngoingItemPanelVisible,
  setBlacklistDataVisible,
  setBlacklistData,
  setBlacklistDataItem,
  setBlacklistItemVisible,
  type,
  applyError,
  applyWarningInProgress,
  applyCustomerOngoingWarningAction,
  batchApplyWarningInProgress,
  batchApplyCustomerOngoingWarningAction,
  batchApplyWarningIsSuccess,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  selectedWarningId,
  status,
  selectedWarningGroup,
  getCustomerWarningsAction,
  paginationInProgress,
  paginationIsFetching,
  getCustomerOngoingWarningByIdAction,
  isWarningByIdLoading,
  isWarningByIdFetching,
  ongoingItemPanelVisible,
  setApplyError,
  blacklistDataVisible,
  blacklistData,
  blacklistItemVisible,
  blacklistItem,
  changeLogsPanelIsOpen,
  setChangeLogPanelIsOpen,
  activePermissions,
  customerId,
  changeLogsIsLoading,
  changeLogs,
  users,
  changeLogsPagination,
  changeLogsIsFetching,
  getChangeLogsAction,
  manualScoreSidepanelVisible,
  aml,
  totalRiskScore,
  setManualScoreSidepanelVisible,
  setTotalRiskScore,
  setTotalRiskScoreLevel,
  setManualRiskScoreError,
  setDirtyPopupVisible,
  manualRiskScoreError,
  createRiskScoreIsLoading,
  createCustomerManualRiskScoreAction,
  totalRiskScoreLevel,
  riskScoreRanges,
  dirtyPopupVisible,
  riskScoreChangeLogsSidepanelVisible,
  getCustomerAmlChangeLogsAction,
  amlChangeLogs,
  handleCloseAmlChangeLogsPanel,
  amlChangeLogsIsLoading,
  amlScoresHistoryIsFetching,
  amlChangeLogsPagination,
}: AMLPanelsTypes) => {
  let ongoingSidepanelContent = <div />;

  if (ongoingItemIsFetching || ongoingItemIsLoading) {
    ongoingSidepanelContent = <SidePanelLoader />;
  } else if (
    !ongoingItemIsFetching &&
    !ongoingItemIsLoading &&
    ongoingMonitoringItem
  ) {
    ongoingSidepanelContent = (
      <OngoingPanelContent
        warnings={ongoingMonitoringItem?.warnings.edges.map(
          (item) => item.node,
        )}
        warningsPagination={ongoingMonitoringItem?.warnings?.pageInfo}
        setOngoingItemPanelVisible={setOngoingItemPanelVisible}
        setBlacklistDataVisible={setBlacklistDataVisible}
        setBlacklistData={setBlacklistData}
        setBlacklistDataItem={setBlacklistDataItem}
        setBlacklistItemVisible={setBlacklistItemVisible}
        type={type}
        blacklists={ongoingMonitoringItem?.warningsGroupsBlacklists?.edges?.map(
          (item) => item?.node?.blacklist?.name,
        )}
        warningGroupId={ongoingMonitoringItem.id}
        applyError={applyError}
        applyWarningInProgress={applyWarningInProgress}
        applyOngoingWarning={applyCustomerOngoingWarningAction}
        batchApplyWarningInProgress={batchApplyWarningInProgress}
        batchApplyOngoingWarning={batchApplyCustomerOngoingWarningAction}
        batchApplyWarningIsSuccess={batchApplyWarningIsSuccess}
        onResetTransactionWarningAction={onResetTransactionWarningAction}
        resetTransactionsWarningIsLoading={resetTransactionsWarningIsLoading}
        resetTransactionsWarningIsSuccess={resetTransactionsWarningIsSuccess}
        selectedWarningId={selectedWarningId}
        status={status}
        selectedWarningGroup={selectedWarningGroup}
        getWarningsAction={getCustomerWarningsAction}
        paginationInProgress={paginationInProgress || paginationIsFetching}
        getOngoingWarningById={getCustomerOngoingWarningByIdAction}
        isWarningByIdLoading={isWarningByIdLoading}
        isWarningByIdFetching={isWarningByIdFetching}
      />
    );
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={exportPdfPanelVisible}
        onClose={() => setExportPdfPanelVisible(false)}
        title="Export Ongoing monitoring"
        sidepanelExpandedKey="export-ongoing-panel"
        footer={
          <>
            <ButtonPrimary
              text={ongoingMonitoringPdfIsLoading ? 'Loading...' : 'Export'}
              onClick={() => getOngoingMonitoringPdfAction()}
              disabled={ongoingMonitoringPdfIsLoading}
              bold
            />
            <ButtonPseudo
              text="Close"
              onClick={() => setExportPdfPanelVisible(false)}
              bold
            />
          </>
        }
      >
        <div className={cn.datePickerRangeWrapper}>
          <div className={cn.datePickerRangeWrapperTitle}>Select period</div>
          <div className={cn.dateRangePickerWrapperContent}>
            <DateInputRange
              title="Select period"
              values={exportDate}
              onChangeRange={(date) =>
                setExportDate(date.map((item) => item.toISOString()))
              }
              placeholder="Select period"
              className={cn.datePickerItem}
              withoutTwoPickers
              withoutCustomSelector
            />
            <IconCalendar className={cn.iconCalendar} />
          </div>
        </div>
      </SidePanel>
      <SidePanel
        type={SidePanelType.Customers}
        closeOnClickOutside
        isOpen={ongoingItemPanelVisible}
        onClose={() => {
          setOngoingItemPanelVisible(false);
          setApplyError('');
        }}
        title="Ongoing monitoring"
        sidepanelExpandedKey="ongoing-panel"
        footer={
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setOngoingItemPanelVisible(false);
              setApplyError('');
            }}
            bold
          />
        }
      >
        {ongoingSidepanelContent}
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistDataVisible}
        onClose={() => {
          setOngoingItemPanelVisible(true);
          setBlacklistDataVisible(false);
          setBlacklistData(undefined);
        }}
        title={blacklistData?.fullName as string}
        sidepanelExpandedKey="ongoing-blacklist-data"
        footer={
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setOngoingItemPanelVisible(true);
              setBlacklistDataVisible(false);
              setBlacklistData(undefined);
            }}
            bold
          />
        }
      >
        <BlacklistDataContent data={blacklistData} />
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistItemVisible}
        onClose={() => {
          setBlacklistDataItem(undefined);
          setBlacklistItemVisible(false);
          setOngoingItemPanelVisible(true);
        }}
        title="User Details"
        sidepanelExpandedKey="ongoing-blacklist-data"
        footer={
          <ButtonPseudo
            text="Close"
            onClick={() => {
              setBlacklistDataItem(undefined);
              setBlacklistItemVisible(false);
              setOngoingItemPanelVisible(true);
            }}
            bold
          />
        }
        withoutExpand
        expanded
      >
        <BlacklistUserInfo info={blacklistItem} isLoading={false} />
      </SidePanel>
      <SidePanel
        isOpen={changeLogsPanelIsOpen}
        onClose={() => {
          setChangeLogPanelIsOpen(false);
        }}
        title="Customer change logs"
        sidepanelExpandedKey="customers-change-logs"
        type={SidePanelType.Accounts}
        footer={
          <div>
            <ButtonPseudo
              text="Close"
              onClick={() => setChangeLogPanelIsOpen(false)}
              bold
            />
          </div>
        }
        closeOnClickOutside
      >
        <>
          {activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <ChangeLogs
              entityType="ORGANIZATION"
              entityId={customerId as string}
              changeLogsIsLoading={changeLogsIsLoading}
              changeLogs={changeLogs}
              activePermission={activePermissions}
              users={users}
              pagination={changeLogsPagination}
              changeLogsIsFetching={changeLogsIsFetching}
              getChangeLogs={getChangeLogsAction}
            />
          )}
          {!activePermissions?.includes(PermissionEnum.AUDIT_LOG_LIST) && (
            <PermissionDenied />
          )}
        </>
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={manualScoreSidepanelVisible}
        onClose={() => {
          if (aml?.totalRiskScore === totalRiskScore) {
            setManualScoreSidepanelVisible(false);
            setTotalRiskScore(0);
            setTotalRiskScoreLevel('');
            setManualRiskScoreError('');
          } else {
            setDirtyPopupVisible(true);
          }
        }}
        title="Set Risk Score manually"
        sidepanelExpandedKey="manual-risk-score"
        errorSidepanel={manualRiskScoreError}
        footer={
          <>
            <ButtonPrimary
              text={createRiskScoreIsLoading ? 'Loading...' : 'Apply'}
              disabled={createRiskScoreIsLoading}
              onClick={createCustomerManualRiskScoreAction}
              bold
            />
            <ButtonPseudo
              text="Close"
              onClick={() => {
                if (aml?.totalRiskScore === totalRiskScore) {
                  setManualScoreSidepanelVisible(false);
                  setTotalRiskScore(0);
                  setTotalRiskScoreLevel('');
                  setManualRiskScoreError('');
                } else {
                  setDirtyPopupVisible(true);
                }
              }}
              bold
            />
          </>
        }
      >
        <ManualRiskScoreForm
          totalRiskScoreLevel={totalRiskScoreLevel}
          riskScoreRanges={riskScoreRanges}
          setTotalRiskScoreLevel={setTotalRiskScoreLevel}
          setTotalRiskScore={setTotalRiskScore}
          totalRiskScore={totalRiskScore}
        />
      </SidePanel>
      <AmlChangeLogs
        panelIsOpen={riskScoreChangeLogsSidepanelVisible}
        getAmlChangeLogs={getCustomerAmlChangeLogsAction}
        amlChangeLogs={amlChangeLogs}
        handleCloseAmlChangeLogsPanel={handleCloseAmlChangeLogsPanel}
        amlChangeLogsIsLoading={amlChangeLogsIsLoading}
        amlScoresHistoryIsFetching={amlScoresHistoryIsFetching}
        type={type}
        users={users}
        organizationId={customerId}
        amlChangeLogsPagination={amlChangeLogsPagination}
      />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={() => {
          setManualScoreSidepanelVisible(false);
          setTotalRiskScore(0);
          setTotalRiskScoreLevel('');
          setManualRiskScoreError('');
        }}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
    </>
  );
};

export default AmlPanels;
